"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IndexedDollarParameter_1 = require("./IndexedDollarParameter");
var IndexedInvestmentOption = (function () {
    function IndexedInvestmentOption() {
        this._investmentOption = null;
        this._annualDollarFee = null;
        this._feePercentageOnBalanceCappedCap = null;
    }
    IndexedInvestmentOption.prototype.initialise = function (investmentOption, indexationBasis) {
        this._investmentOption = investmentOption;
        this._annualDollarFee = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._feePercentageOnBalanceCappedCap = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._annualDollarFee.initialise(this._investmentOption.feeAnnualDollar, indexationBasis);
        this._feePercentageOnBalanceCappedCap.initialise(this._investmentOption.feePercentageOnBalanceCappedCap, indexationBasis);
    };
    IndexedInvestmentOption.prototype.index = function (year) {
        this._annualDollarFee.index(year);
        this._feePercentageOnBalanceCappedCap.index(year);
    };
    Object.defineProperty(IndexedInvestmentOption.prototype, "name", {
        get: function () {
            return this._investmentOption.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IndexedInvestmentOption.prototype, "grossReturn", {
        get: function () {
            return this._investmentOption.grossReturn;
        },
        set: function (thisReturn) {
            this._investmentOption.grossReturn = thisReturn;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IndexedInvestmentOption.prototype, "taxableFraction", {
        get: function () {
            return this._investmentOption.taxableFraction;
        },
        set: function (thisFraction) {
            this._investmentOption.taxableFraction = thisFraction;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IndexedInvestmentOption.prototype, "feePercentageOnBalance", {
        get: function () {
            return this._investmentOption.feePercentageOnBalance;
        },
        set: function (thisFeePercentageOnBalance) {
            this._investmentOption.feePercentageOnBalance = thisFeePercentageOnBalance;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IndexedInvestmentOption.prototype, "feePercentageOnContributions", {
        get: function () {
            return this._investmentOption.feePercentageOnContributions;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IndexedInvestmentOption.prototype, "feeAnnualDollar", {
        get: function () {
            return this._annualDollarFee.value;
        },
        set: function (thisFeeAnnualDollar) {
            this._annualDollarFee.resetValues(thisFeeAnnualDollar);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IndexedInvestmentOption.prototype, "feePercentageOnBalanceCapped", {
        get: function () {
            return this._investmentOption.feePercentageOnBalanceCapped;
        },
        set: function (thisFeePercentageOnBalanceCapped) {
            this._investmentOption.feePercentageOnBalanceCapped = thisFeePercentageOnBalanceCapped;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IndexedInvestmentOption.prototype, "feePercentageOnBalanceCappedCap", {
        get: function () {
            return this._feePercentageOnBalanceCappedCap.value;
        },
        set: function (thisFeePercentageOnBalanceCappedCap) {
            this._feePercentageOnBalanceCappedCap.resetValues(thisFeePercentageOnBalanceCappedCap);
        },
        enumerable: true,
        configurable: true
    });
    return IndexedInvestmentOption;
}());
exports.IndexedInvestmentOption = IndexedInvestmentOption;
//# sourceMappingURL=IndexedInvestmentOption.js.map